import { maybe } from "@saleor/misc";
import moment from "moment";

import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam
} from "../../../../../src/utils/filters";
import { IFilterElement } from "../../../../components/Filter";
import {
  MallOrdersFilterKeys,
  MallOrdersListFilterOpts
} from "../../components/MallOrdersListPage/filters";
import {
  MallOrdersListUrlFilters,
  MallOrdersListUrlFiltersEnum,
  MallOrdersUrlQueryParams
} from "../../url";

export const MALL_ORDERS_FILTERS_KEY = "GrabExpressFilters";

export function getFilterOpts(
  params: MallOrdersListUrlFilters
): MallOrdersListFilterOpts {
  return {
    completedAt: {
      active: maybe(
        () =>
          [params.orderCompleteDateFrom, params.orderCompleteDateTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.orderCompleteDateTo, ""),
        min: maybe(() => params.orderCompleteDateFrom, "")
      }
    }
  };
}

export function getFilterVariables(params: MallOrdersListUrlFilters) {
  return {
    orderDate: getGteLteVariables({
      gte: params.orderCompleteDateFrom
        ? moment(`${params.orderCompleteDateFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : null,
      lte: params.orderCompleteDateTo
        ? moment(`${params.orderCompleteDateTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : null
    }),
    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<MallOrdersFilterKeys>
  //   params: MallOrdersListUrlFilters
): MallOrdersListUrlFilters {
  const { name } = filter;

  switch (name) {
    case MallOrdersFilterKeys.completedAt:
      return getMinMaxQueryParam(
        filter,
        MallOrdersListUrlFiltersEnum.orderCompleteDateFrom,
        MallOrdersListUrlFiltersEnum.orderCompleteDateTo
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<MallOrdersListUrlFilters>(MALL_ORDERS_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  MallOrdersUrlQueryParams,
  MallOrdersListUrlFilters
>({
  ...MallOrdersListUrlFiltersEnum
});
